module.exports = "/_next/static/images/collaborate-mobile@3x-9badf1d07ef4a0301d70460faf1e282f.png";